import './dentist-row.css';
import {
    Card,
    Col,
    Row,
    Image,
} from "react-bootstrap";
// import axios from 'axios';
import React from "react";
import { LinkContainer } from 'react-router-bootstrap';

// import Hello from '../navigationbar/hello'
// import { LinkContainer } from 'react-router-bootstrap'

export default function DentistRow(props) {
    // console.log(props)
    const backup_picture_url ="https://upload.wikimedia.org/wikipedia/commons/thumb/archive/a/ac/20121003093557%21No_image_available.svg/120px-No_image_available.svg.png"
    const clinicData = props.clinicData;
    const dentists = clinicData.dentists;
        return (
            <Card>
                <Card.Header className='font-weight-bold'>
                    Providers at this location
                </Card.Header>
                <Card.Body>

                    {dentists.map(dentist => (


                            <Row key={dentist._id} className='my-2'>
                                <LinkContainer style={{width: "80px", height: "80px", cursor: 'pointer'}} to={{
                                    pathname: `/logged-in/dentists/${dentist.full_name}/`,
                                    state: {clinicData: clinicData, dentist}}}>
                                    <Image className='border' src={`${dentist.picture_url || backup_picture_url}`} roundedCircle />
                                </LinkContainer>
                                <Col> 
                                    
                                    <LinkContainer style={{cursor: 'pointer'}} to={{
                                    pathname: `/logged-in/dentists/${dentist.full_name}/`,
                                    state: {clinicData: clinicData, dentist}}}>
                                        <Card.Text className='font-weight-bold mb-0 '>
                                            {dentist.full_name}
                                        </Card.Text>
                                    </LinkContainer>
                                    <LinkContainer  style={{cursor: 'pointer'}} to={{ 
                                    pathname: `/logged-in/dentists/${dentist.full_name}/`,
                                    state: {clinicData: clinicData, dentist}}}>
                                        <Card.Text>
                                            {dentist.work_title}
                                        </Card.Text>
                                    </LinkContainer>
                                </Col>
                            </Row>


                    ))}

                </Card.Body>
            </Card>
        );
      }
    